import React from "react";
import Navbar from "../components/Navbar";
import "./Home.css";

export default function Home() {
  return (
    <div className="home">
      <Navbar />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>AI Process Optimisation for the Chemical Industry</h1>
          <p>
            Synthera is building the next generation of chemical process
            optimisation. While we’re in development, try our proof-of-concept
            MVP today.
          </p>
          <a href="/try" className="cta-btn">Test the MVP</a>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div>
          <h2>3,800+</h2>
          <p>Potential Use Cases</p>
        </div>
        <div>
          <h2>230+</h2>
          <p>Research Papers Reviewed</p>
        </div>
        <div className="stat">
          <h2>$12B+</h2>
          <p>Global Chemical Process AI Market Potential</p>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <h2>Why Synthera?</h2>
        <p>
          Chemical process optimisation is complex, but our AI-powered solution
          simplifies it. Synthera leverages advanced models to suggest optimal
          parameters for reactions, saving time, resources, and energy.
        </p>
      </section>

      {/* Footer */}
      <footer>
        <p>© 2025 Synthera — AI Process Optimisation</p>
      </footer>
    </div>
  );
}

